export const MANAGE_PAGE_REQUIRED_PROPS = Object.freeze({
    baseUrl: '',
    categoryLinks: {},
    eventButtonsToShow: {
        isPreviewShown: false,
        isPublishShown: false,
        isViewShown: true,
    },
    eventIds: {
        eventId: '37919130139',
        seriesUpcomingEventId: null,
        parentId: null,
    },
    eventStatusData: {
        eventDateRange:
            'Friday, December 29, 2017 at 9:00 PM  -  Saturday, December 30, 2017 at 5:00 AM (PST)',
        name: 'FAKE_DEV_EVENT at 1015 FOLSOM',
        organizerId: '562044966',
        start: '2021-12-31 21:00:00',
        end: '2031-12-31 05:00:00',
        status: 'live',
    },
    isEditShown: true,
    isSaved: true,
    isPaymentOptionsIncomplete: false,
    isPaymentOptionsShown: true,
    isSeriesParent: false,
    isSeriesChild: false,
    manageHeaderAndNavUrls: {
        viewUrl: 'https://markus1015.evbqa.com',
        previewUrl: '/preview?eid=37919130139',
        publishUrl: '/publish?eid=37919130139&crumb=ed23621d76566d',
    },
    pageType: 'manage',
    featureFlags: {
        checkoutSettings: true,
        performances: false,
    },
    isMusicVertical: false,
    showShippingSettings: false,
    isPaidEvent: true,
    organizationId: '1234',
    usesNewPermissions: true,
});
